@if (links.error()) {
  <ideal-error [error]="links.error()"></ideal-error>
} @else {
  <ideal-product-links-view [links]="linkItems()"></ideal-product-links-view>
}
